<payee-popup
  title="Hitelezők összevonása"
  width="750px"
>
  <div class="flex merge-dialog-content">
    <ng-container
      [ngTemplateOutlet]="clientCard"
      [ngTemplateOutletContext]="{
        client: data.masterClient,
        title: 'Fő hitelező (megmarad):',
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="clientCard"
      [ngTemplateOutletContext]="{
        client: data.clientToMerge,
        title: 'Összevonandó hitelező (törlődik):',
      }"
    ></ng-container>
  </div>
  <div class="merge-warning">
    <b>Figyelem!</b>
    Az összevonás után a második hitelező törlődik, és minden kapcsolódó adat átkerül a fő hitelezőhöz.
  </div>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      type="button"
      width="max"
      color="primary"
      (click)="onConfirm()"
    >
      Összevonás
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      type="button"
      width="max"
      (click)="onCancel()"
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>

<ng-template
  #clientCard
  let-client="client"
  let-title="title"
>
  <div class="merge-client-box">
    <div class="merge-client-title">{{ title }}</div>
    <div class="merge-client-value">
      <b>Név:</b>
      {{ client.name }}
    </div>
    <div class="merge-client-value">
      <b>Adószám:</b>
      {{ client.tax_number }}
    </div>
    <div class="merge-client-value">
      <b>Futó ügyek:</b>
      {{ client.open_cases }}
    </div>
    <div class="merge-client-value">
      <b>Lezárt ügyek:</b>
      {{ client.closed_cases }}
    </div>
    @if (client.product_discounts.length) {
      <payee-horizontal-line></payee-horizontal-line>
      <b>Termék kedvezmények:</b>
      <ul class="product-discounts">
        @for (discount of client.product_discounts; track discount.fee.product_type + discount.fee.currency_iso) {
          <li class="discount-item">
            <span>{{ discount.fee.product_type }} - {{ discount.fee.label }}:</span>
            <span>
              {{ discount.discount | number: "1.0" : "hu" }}
              {{ discount.discount_type === "percentage" ? "%" : discount.fee.currency_iso }}
            </span>
          </li>
        }
      </ul>
    }
    @if (client.partners.length) {
      <payee-horizontal-line></payee-horizontal-line>
      <b>Partnerek:</b>
      <ul>
        @for (partner of client.partners; track partner.name) {
          <li [class.duplicate]="duplicatePartners.has(partner.name)">
            {{ partner.name }}
          </li>
        }
      </ul>
    }
    @if (client.users.length) {
      <payee-horizontal-line></payee-horizontal-line>
      <b>Felhasználók:</b>
      <ul>
        @for (user of client.users; track user.email) {
          <li>
            {{ user.email }}
          </li>
        }
      </ul>
    }
    <payee-horizontal-line></payee-horizontal-line>
    <b>Bankszámla:</b>
    <div>
      {{ client.bankAccount.iban || client.bankAccount.account_number }}
    </div>
  </div>
</ng-template>
